import React from "react";
import { Box, Flex, Text, CloseButton } from "@chakra-ui/react";
import { Router } from "@reach/router";
import { About } from "./about";
import { Contribute } from "./contribute";
import { Acknowledgment } from "./acknowledgment";
import { Contacts } from "./contacts";
import { basepath } from "../constants/basepath";

const Home = () => <Box visibility="hidden"></Box>;

export const MapWidgets = ({ id, ref }) => (
  <Box id={id}>
    <Router ref={ref}>
      <Home path={`${basepath}/`} />
      <About path={`${basepath}/about`} />
      <Contribute path={`${basepath}/contribute`} />
      <Acknowledgment path={`${basepath}/acknowledgment`} />
      <Contacts path={`${basepath}/contacts`} />
    </Router>
  </Box>
);
